import { NgModule } from '@angular/core';
import { PulseNpsCountComponent } from './pulse-nps-count.component'; 
import { CommonModule } from '@angular/common';
import {HighchartsChartModule} from "highcharts-angular";
import { AlertModule } from 'ngx-bootstrap/alert';

@NgModule({
  declarations: [PulseNpsCountComponent],
  imports: [
    CommonModule,
    HighchartsChartModule,
    AlertModule.forRoot(),
    
  ],
  exports: [PulseNpsCountComponent],
})
export class PulseNpsCountModule {}
